import {
  CarModelMain,
  extractData,
  getCarmodelGet,
  getHomepageCarStrip,
  getSeoKey,
} from "api"
import slugify from "common/bit/utils/slugify"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import CarModelPage from "components/carModelPage/CarModelPage"

import { GetStaticPaths, GetStaticProps } from "next"

type ModelStaticProps = {
  modelId: string
  modelSlug: string
}
export const getStaticPaths: GetStaticPaths<ModelStaticProps> = async () => {
  const data = await getHomepageCarStrip().then(extractData)
  const paths = data?.body?.cars?.map((model) => ({
    params: {
      modelId: model.id.toString(),
      modelSlug: slugify(model.name),
    },
  }))

  return { paths, fallback: "blocking" }
}

type ModelProps = {
  modelData: CarModelMain
  seo: SeoMetadataWithImage
}

export const getStaticProps: GetStaticProps<
  ModelProps,
  ModelStaticProps
> = async ({ params }) => {
  const data = await getCarmodelGet(parseInt(params.modelId)).then(extractData)
  const seoData = await getSeoKey(params.modelSlug)
  const seo = {
    title: seoData?.data?.body?.title || "",
    description: seoData?.data?.body?.description || "",
    keywords: seoData?.data?.body?.keywords || "",
    image: data?.body?.generalInfo?.image || null,
  }
  if (!data || !data.body) {
    return {
      redirect: { destination: "/models", permanent: false },
      revalidate: 60,
    }
  }
  return { props: { modelData: data?.body, seo: seo }, revalidate: 60 }
}

const Model = ({ modelData, seo }: ModelProps) => {
  return (
    <>
      <SeoMetaData data={seo} />
      <CarModelPage data={modelData} />
    </>
  )
}

export default Model
